<br><br><br><br><br><br>
<div class="form-gap"></div>
    <div class="d-flex justify-content-center">
		<div class="col-md-4 col-md-offset-4">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h2 class="text-center">Saisir un nouveau mot de passe </h2>
                  <p>Veillez saisir un nouveau mot de passe </p>
                  <div class="panel-body">
    
                    <form id="register-form" role="form" autocomplete="off" class="form" method="post">
    
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                          <input  [(ngModel)]="password" id="email" name="password" placeholder="Mot de passe" class="form-control"  type="password">
                        </div>
                        <div class="input-group">
                            <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                            <input  [(ngModel)]="passwordConfirm" id="passwordConfirm" name="passwordConfirm" placeholder="Confirmation mot de passe" class="form-control"  type="password">
                          </div>
                      </div>
                      <div class="form-group">

                        <input *ngIf="!showSpinner" (click)="updatePassword()" name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Réinitialiser mot de passe" type="submit">

                        <button *ngIf="showSpinner" (click)="updatePassword()" name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Réinitialiser mot de passe" type="submit">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...
                        </button>
                      </div>
                      
                    </form>
                    <mat-error  *ngIf="passwordnotconfirmed"> Le mot de passe ne confirme pas </mat-error>

                  </div>
                </div>
              </div>
            </div>
        </div>
</div>
<br><br><br><br><br><br><br><br>